import { Text, TopBar } from '@domain-group/suit-theme'

import useLoginAsUser from '@hooks/useLoginAsUser'

import type { FormattedResult } from '@hooks/useDashboardSearch'

import Action from '../Action'

interface ResultProps {
  isMobile: boolean,
  isSidebar?: boolean,
  result: FormattedResult,
}

const Result = (props:ResultProps) => {
  const {
    isMobile,
    isSidebar = false,
    result,
    result: {
      // @ts-expect-error TS2339
      actions, icon, loginAsUserParams, onClick, shouldUseLegacyLogin, tertiaryText,
    },
  } = props

  const { callbacks: { loginAsUser } } = useLoginAsUser(loginAsUserParams)

  const isSidebarOrMobile = isSidebar || isMobile

  const loginFn = shouldUseLegacyLogin ? loginAsUser : onClick

  const updatedResult = {
    ...result,
    onClick: !actions || isSidebarOrMobile ? () => loginFn() : null,
  }

  return (
    // @ts-expect-error TS2322
    <TopBar.Result icon={icon} result={updatedResult}>
      {!isSidebarOrMobile && (
        <>
          {tertiaryText && (
            <Text color="bodyFontLightColor" fontSize="xsmall">{tertiaryText}</Text>
          )}

          {actions && (
            // @ts-expect-error TS7006
            actions.map((item, index) => (
              <Action index={index} item={item} />
            ))
          )}
        </>
      )}

    </TopBar.Result>
  )
}

export default Result
